module.exports = __webpack_public_path__ + "img/hot.adef815.png";